<template>
  <div>
    <div class="d-flex align-center">
      <div>
        <v-btn @click="$router.push('main')" class="left-arrow" icon>
          <v-icon>mdi-arrow-top-left</v-icon>
        </v-btn>
      </div>
      <div class="ml-2">
        <span class="market-header">Markets</span>
      </div>
    </div>

    <v-card elevation="2" class="my-5">
      <v-card-title>
        <div class="header">Global Markets</div>
      </v-card-title>
      <v-card-text class="pb-0">
        <TickerTape />
      </v-card-text>
    </v-card>
    <v-card elevation="2" class="my-5">
      <v-card-title>
        <div class="header">Market Movers</div>
      </v-card-title>
      <v-card-text class="pb-0">
        <StockMarket />
      </v-card-text>
    </v-card>
    <v-card elevation="2" class="mt-5 mb-10 pb-10">
      <v-card-title>
        <div class="header">Market Performance</div>
      </v-card-title>
      <v-card-text class="pb-0">
        <HeatMap />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import TickerTape from "@/components/Trending/Widgets/TickerTape.vue";
import StockMarket from "@/components/Trending/Widgets/StockMarket.vue";
import HeatMap from "@/components/Trending/Widgets/HeatMap.vue";

export default {
  components: { TickerTape, StockMarket, HeatMap },
};
</script>

<style lang="scss" scoped>
.market-header {
  color: hsl(0deg 0% 0% / 87%);
  font-family: Avenir;
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.header {
  font-family: Avenir;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.left-arrow {
  transform: rotate(-45deg);
}
</style>
